import { render, staticRenderFns } from "./FeeUpdate.vue?vue&type=template&id=3639d6a5&"
import script from "./FeeUpdate.vue?vue&type=script&lang=js&"
export * from "./FeeUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports